import { DatePicker as AntDatePicker } from "antd";
// import styled from 'styled-components';

export const DatePicker = AntDatePicker;
